import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import * as yup from 'yup';
import apiClient from '../../../../Services/ApiClient';
import { FormValues } from '../../../MagicForm/Interfaces/FormValues';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import InputField from '../../../../Components/Form/components/InputField';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	patientId: string;
	onSuccess?: (needReload: boolean) => void;
}

const ECardAddFolder: React.FC<Props> = ({ onSuccess, patientId }) => {
	const { t } = useTranslation();

	const handleSave = async (values: FormValues) => {
		const folderId = uuidv4();
		const documentationUrl =
			'/patients/' + patientId + '/documentation/' + folderId;

		await apiClient.post(documentationUrl, {
			name: values.name,
		});

		onSuccess?.(true);
	};

	const validationSchema = yup.object({
		name: yup.string().required(t('base.folderName')),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	return (
		<FormWrapper formMethods={formMethods} registerForChanges>
			<InputField
				name='name'
				label='base.folderName'
				className='mb-3'
				isRequired
			/>
			<div className={'mt-4'}>
				<SubmitButton title={'base.shared.save'} onSubmit={handleSave} />
			</div>
		</FormWrapper>
	);
};

export default ECardAddFolder;
